import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { msalConfigCaps } from './authConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

// MSAL v5 redirect bridge: the IdP redirects back to the configured redirectUri
// (the `/terms` path). That page must hand the auth response back to the main
// app via broadcastResponseToMainFrame() and must NOT mount MsalProvider,
// otherwise MSAL processes the response hash before the bridge can run and the
// user is dropped back on the login screen.
if (window.location.pathname.endsWith('/terms')) {
  broadcastResponseToMainFrame().catch((error) => {
    console.error('Error broadcasting auth response to main frame:', error);
  });
  root.render(<p>Processing sign-in…</p>);
} else {
  const msalInstance = new PublicClientApplication(msalConfigCaps);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
